import type { ComponentProps, ReactNode } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

function ResponsiveTable({
  children,
  ...props
}: ComponentProps<"table"> & { children?: ReactNode }) {
  return (
    <div
      className="markdown-table-region"
      role="region"
      aria-label="Scrollable table"
      tabIndex={0}
    >
      <table {...props}>{children}</table>
      <span className="markdown-table-hint" aria-hidden="true">
        Swipe to view all columns
      </span>
    </div>
  );
}

export function MarkdownContent({
  children,
  className = "",
}: {
  children: string;
  className?: string;
}) {
  return (
    <div className={`responsive-markdown ${className}`.trim()}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{ table: ResponsiveTable }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
